import './css/Slider.css';

function Slider() {
  return (
    <div className="Slider">
      <div className="container-left">
        <p className="text-left">Chat</p>
      </div>
      <div className="container-right">
        <p className="text-right">App</p>
      </div>
    </div>
  );
}
export default Slider;
